<template>
  <Documents />
</template>

<script>
import Documents from '../components/Documents'

export default {
  name: 'DocumentsPage',
  components: {
    Documents
  }
}
</script>
